import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import { useService } from '@atlassian/help-center-common-util/use-service';
import { usePfErrorUtils } from '@atlassian/proforma-common-core/error-utils-context';

import { proformaGasAnalyticsFetch } from '../../common/services/proforma-gas-analytics-fetch';

interface AffectedService {
	id: string;
	name: string;
}

export interface AffectedServicesResponse {
	services: AffectedService[];
}

export const useAffectedServicesService = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const errorUtils = usePfErrorUtils();

	const request = useCallback(
		(query: string) =>
			proformaGasAnalyticsFetch<AffectedServicesResponse>(
				`/rest/service-registry-api/service?query=${encodeURIComponent(query)}`,
				{ method: 'GET' },
				createAnalyticsEvent,
				errorUtils,
			),
		[createAnalyticsEvent, errorUtils],
	);

	return useService(request);
};
